
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MenuData } from '../models/menu/menu.models';

@Injectable({ providedIn: 'root' })
export class MenuService {
  constructor(private http: HttpClient) {}

  load(): Observable<MenuData> {
    return this.http.get<MenuData>('assets/configs/menu.json');
  }
}